import React, { useState } from "react";
import { useAuthStore } from "../store/useAuthStore";
import { useNavigate } from "react-router";

const LoginPage = () => {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const { login } = useAuthStore();

    const loginUserFunction = async () => {
        try {
            setLoading(true);
            await login(email, password);
            // navigate("/dashboard")
        } catch (error) {
            console.error("Login error:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex justify-center items-center min-h-screen bg-gray-100">
            <div className="bg-white flex rounded-xl shadow-lg overflow-hidden max-w-4xl w-full">
                {/* Left Side - Form */}
                <div className="w-1/2 p-12 h-[70vh] flex flex-col justify-center">
                    <h2 className="text-2xl font-bold mb-6">Log in</h2>

                    {/* Email Input */}
                    <div className="mb-4">
                        <label className="block text-gray-700 text-sm mb-1">Email</label>
                        <div className="flex items-center border-b-2 border-yellow-500">
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Enter your email address"
                                className="flex-1 py-2 focus:outline-none"
                            />
                        </div>
                    </div>

                    {/* Password Input */}
                    <div className="mb-6">
                        <label className="block text-gray-700 text-sm mb-1">Password</label>
                        <div className="flex items-center border-b-2 border-gray-300">
                            <input
                                type={showPassword ? "text" : "password"}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Enter your Password"
                                className="flex-1 py-2 focus:outline-none"
                            />
                            <button
                                type="button"
                                className="text-gray-400"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? "🙈" : "👁️"}
                            </button>
                        </div>
                    </div>

                    {/* Login Button */}
                    <button
                        onClick={loginUserFunction}
                        disabled={loading}
                        className={`w-full flex items-center justify-center bg-yellow-500 text-white py-2 rounded transition 
              ${loading ? "opacity-70 cursor-not-allowed" : "hover:bg-yellow-600"}`}
                    >
                        {loading ? (
                            <div className="flex items-center gap-2">
                                <svg
                                    className="animate-spin h-5 w-5 text-white"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <circle
                                        className="opacity-25"
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        stroke="currentColor"
                                        strokeWidth="4"
                                    ></circle>
                                    <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                                    ></path>
                                </svg>
                                Processing...
                            </div>
                        ) : (
                            "Login"
                        )}
                    </button>
                </div>

                {/* Right Side - Image */}
                <div className="w-1/2 bg-gray-50 flex justify-center items-center">
                    <img
                        src={"./emergenciImg1.png"}
                        alt="login visual"
                        className="w-full h-full object-cover rounded-r-xl"
                    />
                </div>
            </div>
        </div>
    );
};

export default LoginPage;
